var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57422 1.74609L5.32031 5L8.57422 8.25391L7.75391 9.07422L4.5 5.82031L1.24609 9.07422L0.425781 8.25391L3.67969 5L0.425781 1.74609L1.24609 0.925781L4.5 4.17969L7.75391 0.925781L8.57422 1.74609Z",
    fill: "#5E5D5D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-close-icon.8235f9dd.svg";
export { ForwardRef as ReactComponent };